import React, { Component } from 'react'
import { Container, Row, Col, Form } from 'react-bootstrap';
import getConfig from 'next/config';
const { serverRuntimeConfig, publicRuntimeConfig } = getConfig();
import Link from 'next/link';
import Cbutton from '../../components/button';

export default class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            services: [
                {
                    "id": 1,
                    "image": 'ux-consulting-icon.svg',
                    "head": 'UX Consulting',
                    "isCheck": false
                },
                {
                    "id": 2,
                    "image": 'ui-ux-icon.svg',
                    "head": 'UI Design',
                    "isCheck": false
                },
                {
                    "id": 3,
                    "image": 'ios-icon.svg',
                    "head": 'IOS',
                    "isCheck": false
                },
                {
                    "id": 4,
                    "image": 'android-icon.svg',
                    "head": 'Android',
                    "isCheck": false
                },
                {
                    "id": 5,
                    "image": 'android-icon.svg',
                    "head": "Hybrid App's",
                    "isCheck": false
                },
                {
                    "id": 6,
                    "image": 'web-app-icon.svg',
                    "head": 'Data Analytics',
                    "isCheck": false
                },
                {
                    "id": 7,
                    "image": 'ui-ux-icon.svg',
                    "head": 'ERP/CRM',
                    "isCheck": false
                },
                {
                    "id": 8,
                    "image": 'ui-ux-icon.svg',
                    "head": 'Dashboards',
                    "isCheck": false
                },
                {
                    "id": 9,
                    "image": 'ios-icon.svg',
                    "head": 'Tech Consulting',
                    "isCheck": false
                },
                {
                    "id": 10,
                    "image": 'ui-ux-icon.svg',
                    "head": 'E-Commerce',
                    "isCheck": false
                },
                {
                    "id": 11,
                    "image": 'android-icon.svg',
                    "head": 'Dgt Marketing',
                    "isCheck": false
                },
                {
                    "id": 12,
                    "image": 'android-icon.svg',
                    "head": 'Branding',
                    "isCheck": false
                }
            ],
            next: false,
            nextForm: false,
            specifications: [
                {
                    "id": 1,
                    "image": 'idea-icon.svg',
                    "head": 'I just have',
                    "content": 'an idea',
                    "isCheck": false
                },
                {
                    "id": 2,
                    "image": 'document-icon.svg',
                    "head": 'I have a brief',
                    "content": 'document',
                    "isCheck": false
                },
                {
                    "id": 3,
                    "image": 'wire-frames-icon.svg',
                    "head": 'I have wireframes',
                    "content": <br />,
                    "isCheck": false
                }
            ]
        }
    }

    componentDidMount(){
        localStorage.removeItem('list')
        localStorage.removeItem('specifications')
    }

    selectIem = (event) => {
        let { services } = this.state
        var count = 0
        var list = ''
        services.find(res => {if (event.id == res.id) res.isCheck = !res.isCheck})
        services.map(res => {if (res.isCheck == true) count = count + 1})
        if (count != 0) {this.setState({next: true})} 
        else {this.setState({next: false})
        }
        services.map(res => {if(res.isCheck == true){if(list == ''){list = res.head }else{list = list+','+res.head}}})
        localStorage.setItem('list',list)
        var result = services
        this.setState({services: result})
    }

    specification = (event) => {
        let { specifications } = this.state
        var count = 0
        var list = ''
        specifications.find(res => {if (event.id == res.id) res.isCheck = !res.isCheck})
        specifications.map(res => {if (res.isCheck == true) {count = count + 1}})
        if (count != 0) {this.setState({nextForm: true})}else {this.setState({nextForm: false})}
        specifications.map(res => {if(res.isCheck == true){if(list == ''){list = res.head + " " + res.content}else{list = list+','+res.head}}})
        localStorage.setItem('specifications',list)
        var result = specifications
        this.setState({specifications: result})
    }

    render() {
        let { services, next, specifications, nextForm } = this.state
        return (
            <div>
                <Row className="pt-sm-5">
                    {services.map((res, index) => (
                        <Col md={2} className="pr-sm-0" key={index}>
                            <div className={res.isCheck == true ? "text-center spectial-border bg-spectial-border pt-4 pb-4 mt-3" : "text-center spectial-border pt-4 pb-4 mt-3"} onClick={() => this.selectIem(res)}>
                                <img src={`${publicRuntimeConfig.staticFolder}/services-img/` + res.image} alt="gt-tv" className="mt-sm-2" />
                                <div className="case-study-heading">{res.head}</div>
                                {res.isCheck ? <img src={`${publicRuntimeConfig.staticFolder}/images/check.svg`} alt="gt-tv" className="mt-2" />
                                    : <div className="uncheck"></div>}
                            </div>
                        </Col>
                    ))}
                    {next && <div className="text-right w-100 pt-3">
                        <Link href="#mdo"><a className="hover-p pl-3">Next >></a></Link>
                    </div>}
                </Row>
                <div className="pt-5 mt-sm-5" id="mdo">
                    <section className="mb-sm-5 pb-sm-5">
                        <Container>
                            <Row>
                                <Col>
                                    <div className="get-sdf-heading">
                                        Do you have any specifications?
                                 </div>
                                </Col>
                                <Col md={3} className="spectial-left-border">
                                    <div className="mt-5 mb-3 pt-sm-1 pb-4">
                                    <a href="tel: 988 581 2693" className="link-action">
                                        <Cbutton name="Talk to us" />
                                    </a>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="pt-sm-5">
                                {specifications.map((result, index) => (
                                    <Col key={index} md>
                                        <div className={result.isCheck == true ? "text-center spectial-border bg-spectial-border pt-4 pb-4 mt-3" : "text-center spectial-border pt-4 pb-4 mt-3"} onClick={() => this.specification(result)}>
                                            <img src={`${publicRuntimeConfig.staticFolder}/services-img/` + result.image} alt="gt-bulb" className="mt-2" />
                                            <div className="case-study-heading pt-sm-3 custome-h">{result.head}</div>
                                            <div className="case-study-heading custome-h">{result.content}</div>
                                            {result.isCheck ? <img src={`${publicRuntimeConfig.staticFolder}/images/check.svg`} alt="gt-tv" className="mt-2" />
                                                : <div className="uncheck"></div>}
                                        </div>
                                    </Col>
                                ))}
                                {nextForm && <div className="text-right w-100 pt-3">
                                    <Link href="#form"><a className="hover-p pl-3">Next >></a></Link>
                                </div>}
                            </Row>
                        </Container>
                    </section>
                </div>
                <style jsx>
                    {`
                    .spectial-border{
                        cursor: pointer !important;
                    }
                    .bg-spectial-border{
                        background: #ff740005;
                    }
                    .uncheck{
                        border: 1px solid gray;
                        width: 32px;
                        height: 32px;
                        border-radius: 100%;
                        margin: auto;
                        margin-top: 5px;
                    }
                    .hover-p{
                        cursor: pointer !important;
                        background: #ff7400;
                        padding: 6px 10px;
                        color: #ffffff;
                        letter-spacing: 1px;
                    }
                    .hover-p:hover{
                        text-decoration: none;
                    }
                    #mdo .case-study-heading{
                        font-size: 24px !important;
                    }
                    `}
                </style>
            </div>
        )
    }
}
